module.exports = __webpack_public_path__ + "img/DealerIcons-PDM-Off.bdc85f7.jpg";